import { Component } from 'preact'
import ReactCrop from 'react-image-crop'
import { maxImageFileSize } from 'libs/constants'
import FakeFileUploader from '../ui-components/FakeFileUploader'
import Modal from '../../components/reactModal'
import Button from '../ui-components/Button'

class ImageUploader extends Component {
  constructor () {
    super()
    this.state = {
      src: null,
      crop: {
        x: 0,
        y: 0,
        height: 100
      },
      pixelCrop: null,
      errorMessage: null,
      enableModal: true,
      uploading: false
    }
    this.uploader = null

    let element = document.getElementById('csrftoken')
    if (element) {
      this.csrf = element.value
    }

    this.saveImage = this.saveImage.bind(this)
  }

  onSelectFile (e) {
    let reader = new window.FileReader()
    if (e.target.files && e.target.files.length > 0) {
      if (!['image/png', 'image/jpeg', 'image/gif'].includes(e.target.files[0].type)) {
        this.setState({ errorMessage: 'Sorry, this file type is not supported.' })
        return
      }
      if (e.target.files[0].size > maxImageFileSize) {
        this.setState({ errorMessage: 'Sorry, the file size is too large' })
        return
      }
      reader.addEventListener('load', () => this.setState({ src: reader.result, errorMessage: null }))
      reader.readAsDataURL(e.target.files[0])
    }
  }

  saveImage () {
    this.setState({
      uploading: true
    })
    let formData = new window.FormData()
    const file = this.uploader.files[0]

    formData.append('image', file)
    formData.append('yip_csrf_token', this.csrf)
    if (this.state.pixelCrop) {
      formData.append('crop_coords[x]', Math.round(this.state.pixelCrop.x))
      formData.append('crop_coords[y]', Math.round(this.state.pixelCrop.y))
      formData.append('crop_coords[width]', Math.round(this.state.pixelCrop.width))
      formData.append('crop_coords[height]', Math.round(this.state.pixelCrop.height))
    }

    let xhr = new window.XMLHttpRequest()
    xhr.addEventListener('readystatechange', (evt) => {
      if (evt.target.readyState === 4 && evt.target.status === 200 && evt.target.responseText) {
        this.uploader.value = ''
        this.props.onUploaded(JSON.parse(evt.target.responseText))
        this.setState({
          src: null,
          uploading: false
        })
      }
    }, false)

    xhr.open('POST', '/attachment/new', true)
    xhr.send(formData)
  }

  componentDidMount () {
    const crop = Object.assign({}, this.state.crop, { aspect: this.props.width / this.props.height })
    this.setState({ crop })
  }

  cancelUpload () {
    this.setState({ src: null })
    this.uploader.value = ''
  }

  render (props, state) {
    const isForum = window.inSidedData?.communityId
    const saveBtnClass = `${!isForum ? 'btn btn-primary' : ''} btn--insided-brand ${state.uploading ? 'is-loading' : ''}`

    return <div className={'image-cropper_uploader'}>
      {state.errorMessage && (<div className={'validation-error'}>{state.errorMessage}</div>)}
      <FakeFileUploader>
        <input
          type='file'
          hidden
          ref={(ref) => { this.uploader = ref; props.uploaderRef(ref) }}
          onChange={(e) => this.onSelectFile(e)}
          accept={'image/png|image/jpeg|image/gif'}
        />
      </FakeFileUploader>
      <Modal isOpen={state.src} onClose={() => this.cancelUpload()}>
        <div className='image-cropper_title'>Crop Image</div>
        <div className='image-cropper'>
          <ReactCrop
            src={state.src}
            crop={state.crop}
            onChange={(crop, pixelCrop) => this.setState({ crop: crop, pixelCrop: pixelCrop })}
          />
        </div>
        <div className='image-cropper_footer'>
          <div class='image-cropper_footer-buttons-group'>
            <Button class={saveBtnClass} type='button' onClick={() => this.saveImage()}>Save</Button>
            <Button class={`${!isForum ? 'button-control--secondary btn btn-default' : ''} btn--insided-secondary-brand`} type='button' onClick={() => this.cancelUpload()}>Cancel</Button>
          </div>
          <Button class={`${!isForum ? 'button-control--secondary btn btn-default' : ''} btn--insided-secondary-brand`} type='button' onClick={() => this.uploader.click()}>Choose a new image</Button>
        </div>
      </Modal>
    </div>
  }
}

export default ImageUploader
